
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import * as React from 'react';

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function SvgChevronArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.22 16.474a.614.614 0 010-.942l5.998-5.336a.814.814 0 011.059 0 .616.616 0 010 .942l-5.467 4.861 5.47 4.864a.614.614 0 010 .942.817.817 0 01-1.06 0l-6-5.33z"
  })));
}

export { SvgChevronArrowLeft as default };
//# sourceMappingURL=chevron-arrow-left.svg.js.map
